module.exports = __webpack_public_path__ + "img/detective.bd814ca4.png";